export default __webpack_public_path__ + "static/media/controlAccordionOpen24.3ae8706b.svg";